import { Box, Modal, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import React from 'react';

interface RemoveCardModalProps {
  open: boolean;
  onRemove: () => void;
  onCloseSignal: () => void;
  onClosed?: () => void;
  title?: string;
  message: string;
  hint?: string;
  /**
   * @default Remove
   */
  primaryActionText?: string;
}

export const RemoveModal: React.FC<RemoveCardModalProps> = ({
  open,
  onRemove,
  onCloseSignal,
  onClosed,
  title = intl.formatMessage({ defaultMessage: 'Are you sure?', id: '2oCaym' }),
  message,
  hint,
  primaryActionText = intl.formatMessage({ defaultMessage: 'Remove', id: 'G/yZLu' }),
}) => (
  <Modal
    data-component="RemoveModal"
    onCloseSignal={onCloseSignal}
    onClosed={onClosed}
    open={open}
    size="small"
    testId="remove-modal"
  >
    <Modal.Header onCloseSignal={onCloseSignal}>
      <Text appearance="bodyLargeBold" color="emphasized">
        {title}
      </Text>
    </Modal.Header>
    <Modal.Body>
      <Box
        padding={4}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        gap={12}
      >
        <Text
          appearance={hint ? 'bodyMediumBold' : 'bodyMedium'}
          color={hint ? 'emphasized' : 'default'}
        >
          {message}
        </Text>
        {hint && (
          <Text appearance="bodySmall" color="hint">
            {hint}
          </Text>
        )}
      </Box>
    </Modal.Body>
    <Modal.FooterActions
      primaryAction={{
        action: () => {
          onRemove();
          onCloseSignal();
        },
        text: primaryActionText,
        variant: 'fill-destructive',
      }}
      secondaryAction={{
        action: onCloseSignal,
        text: intl.formatMessage({
          defaultMessage: 'Cancel',
          id: '47FYwb',
        }),
      }}
    />
  </Modal>
);
